import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
import { UserSchema } from '../../entities/user/user.schema';
import { BaseErrorSchema } from '../../shared/error.schema';
import { SupportedLanguageSchema } from '../../shared/language.schema';
/**
 * Update Profile Request Schema
 * PATCH /api/v2/profile
 * Allows users to update their own profile information
 * Only editable fields: firstName, lastName, language
 */ export const UpdateProfileRequestSchema = z.object({
    firstName: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    lastName: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    language: SupportedLanguageSchema.optional()
});
/**
 * Update Profile Response Schema
 * Returns the updated user object
 */ export const UpdateProfileResponseSchema = z.object({
    user: UserSchema
});
/**
 * Update Profile Error Schema
 */ export const UpdateProfileErrorSchema = BaseErrorSchema;

//# sourceMappingURL=update-profile.schema.js.map